module.exports = __webpack_public_path__ + "img/upload.b237ee20.svg";